<div class="space-y-4">
  @if (showTitle()) {
    <div class="flex items-center justify-between flex-wrap gap-2">
      <span class="text-xs font-bold text-neutral-12 uppercase tracking-wider flex items-center gap-2">
        <mat-icon class="w-4! h-4! text-base! text-primary-9">schedule</mat-icon>
        {{ title() }}
      </span>

      <button
        type="button"
        class="text-xs font-semibold text-primary-11 hover:text-primary-12 hover:underline cursor-pointer flex items-center gap-1"
        (click)="applyMondayToWeekdays()"
      >
        <mat-icon class="w-3.5! h-3.5! text-sm!">content_copy</mat-icon>
        Copier les horaires du lundi sur Lun - Ven
      </button>
    </div>
  }

  <!-- Grille des 7 jours de la semaine -->
  <div class="space-y-2.5">
    @for (d of daysMeta; track d.key) {
      @let sched = getDaySchedule(d.key);
      <div
        class="p-3.5 rounded-xl border transition-all flex flex-col md:flex-row md:items-center justify-between gap-3 shadow-2xs"
        [class.bg-white]="sched.isOpen"
        [class.dark:bg-neutral-2]="sched.isOpen"
        [class.border-neutral-3]="sched.isOpen"
        [class.dark:border-neutral-4]="sched.isOpen"
        [class.bg-neutral-2/40]="!sched.isOpen"
        [class.dark:bg-neutral-3/30]="!sched.isOpen"
        [class.border-neutral-2]="!sched.isOpen"
        [class.dark:border-neutral-3/50]="!sched.isOpen"
      >
        <!-- Jour + Bouton Ouvert/Fermé -->
        <div class="flex items-center gap-3 min-w-32.5">
          <button
            type="button"
            class="px-2.5 py-1 rounded-lg text-xs font-bold border transition-all cursor-pointer"
            [class.bg-primary-9]="sched.isOpen"
            [class.text-white]="sched.isOpen"
            [class.border-primary-9]="sched.isOpen"
            [class.bg-neutral-2]="!sched.isOpen"
            [class.dark:bg-neutral-3]="!sched.isOpen"
            [class.text-neutral-9]="!sched.isOpen"
            [class.dark:text-neutral-10]="!sched.isOpen"
            [class.border-neutral-3]="!sched.isOpen"
            [class.dark:border-neutral-4]="!sched.isOpen"
            (click)="toggleDayOpen(d.key)"
          >
            {{ sched.isOpen ? 'Ouvert' : 'Fermé' }}
          </button>
          <span class="text-xs font-bold text-neutral-12">{{ d.label }}</span>
        </div>

        <!-- Options horaires quand ouvert -->
        @if (sched.isOpen) {
          <div class="flex-1 flex flex-col sm:flex-row sm:items-center justify-end gap-3 flex-wrap">
            <!-- Checkbox Sur RDV -->
            <mat-checkbox
              [checked]="sched.byAppointmentOnly || false"
              (change)="toggleDayByAppointment(d.key)"
              class="text-xs"
            >
              <span class="text-xs text-neutral-11">Sur RDV uniquement</span>
            </mat-checkbox>

            @if (!sched.byAppointmentOnly) {
              <div class="flex items-center gap-2 flex-wrap">
                <!-- Bloc Matin -->
                <div
                  class="flex items-center gap-1.5 px-2 py-1 rounded-lg border text-xs transition-colors"
                  [class.bg-white]="isMorningOpen(sched)"
                  [class.dark:bg-neutral-3/70]="isMorningOpen(sched)"
                  [class.border-neutral-4]="isMorningOpen(sched)"
                  [class.dark:border-neutral-5]="isMorningOpen(sched)"
                  [class.bg-neutral-2/50]="!isMorningOpen(sched)"
                  [class.dark:bg-neutral-3/30]="!isMorningOpen(sched)"
                  [class.border-dashed]="!isMorningOpen(sched)"
                  [class.border-neutral-3]="!isMorningOpen(sched)"
                  [class.dark:border-neutral-4]="!isMorningOpen(sched)"
                >
                  <button
                    type="button"
                    class="text-[11px] font-bold transition-all cursor-pointer flex items-center gap-1 py-0.5 px-1.5 rounded"
                    [class.bg-primary-2]="isMorningOpen(sched)"
                    [class.dark:bg-primary-a3]="isMorningOpen(sched)"
                    [class.text-primary-11]="isMorningOpen(sched)"
                    [class.bg-neutral-3]="!isMorningOpen(sched)"
                    [class.dark:bg-neutral-4]="!isMorningOpen(sched)"
                    [class.text-neutral-9]="!isMorningOpen(sched)"
                    [class.dark:text-neutral-11]="!isMorningOpen(sched)"
                    (click)="toggleMorningOpen(d.key)"
                    [title]="isMorningOpen(sched) ? 'Fermer le matin' : 'Ouvrir le matin'"
                  >
                    <mat-icon class="w-3.5! h-3.5! text-xs!">{{
                      isMorningOpen(sched) ? 'wb_sunny' : 'block'
                    }}</mat-icon>
                    <span>Matin</span>
                  </button>

                  @if (isMorningOpen(sched)) {
                    <input
                      type="time"
                      class="px-1.5 py-0.5 bg-neutral-1 dark:bg-neutral-2 border border-neutral-3 dark:border-neutral-4 text-neutral-12 rounded text-xs font-mono w-20"
                      [value]="sched.morningOpen || '09:00'"
                      (change)="onDayTimeChange(d.key, 'morningOpen', $any($event.target).value)"
                      aria-label="Ouverture matin"
                    />
                    <span class="text-neutral-8 dark:text-neutral-9">-</span>
                    <input
                      type="time"
                      class="px-1.5 py-0.5 bg-neutral-1 dark:bg-neutral-2 border border-neutral-3 dark:border-neutral-4 text-neutral-12 rounded text-xs font-mono w-20"
                      [value]="sched.morningClose || '12:00'"
                      (change)="onDayTimeChange(d.key, 'morningClose', $any($event.target).value)"
                      aria-label="Fermeture matin"
                    />
                    <button
                      type="button"
                      class="p-0.5 rounded text-neutral-8 dark:text-neutral-9 hover:text-error-11 hover:bg-error-2 dark:hover:bg-error-3/30 transition-colors cursor-pointer"
                      title="Fermer le matin"
                      (click)="toggleMorningOpen(d.key)"
                    >
                      <mat-icon class="w-3.5! h-3.5! text-xs!">close</mat-icon>
                    </button>
                  } @else {
                    <span class="text-[11px] text-neutral-9 dark:text-neutral-10 italic px-1">Fermé</span>
                    <button
                      type="button"
                      class="text-[11px] font-semibold text-primary-11 hover:underline cursor-pointer px-1"
                      (click)="toggleMorningOpen(d.key)"
                    >
                      Ouvrir
                    </button>
                  }
                </div>

                <!-- Bloc Après-midi -->
                <div
                  class="flex items-center gap-1.5 px-2 py-1 rounded-lg border text-xs transition-colors"
                  [class.bg-white]="isAfternoonOpen(sched)"
                  [class.dark:bg-neutral-3/70]="isAfternoonOpen(sched)"
                  [class.border-neutral-4]="isAfternoonOpen(sched)"
                  [class.dark:border-neutral-5]="isAfternoonOpen(sched)"
                  [class.bg-neutral-2/50]="!isAfternoonOpen(sched)"
                  [class.dark:bg-neutral-3/30]="!isAfternoonOpen(sched)"
                  [class.border-dashed]="!isAfternoonOpen(sched)"
                  [class.border-neutral-3]="!isAfternoonOpen(sched)"
                  [class.dark:border-neutral-4]="!isAfternoonOpen(sched)"
                >
                  <button
                    type="button"
                    class="text-[11px] font-bold transition-all cursor-pointer flex items-center gap-1 py-0.5 px-1.5 rounded"
                    [class.bg-primary-2]="isAfternoonOpen(sched)"
                    [class.dark:bg-primary-a3]="isAfternoonOpen(sched)"
                    [class.text-primary-11]="isAfternoonOpen(sched)"
                    [class.bg-neutral-3]="!isAfternoonOpen(sched)"
                    [class.dark:bg-neutral-4]="!isAfternoonOpen(sched)"
                    [class.text-neutral-9]="!isAfternoonOpen(sched)"
                    [class.dark:text-neutral-11]="!isAfternoonOpen(sched)"
                    (click)="toggleAfternoonOpen(d.key)"
                    [title]="isAfternoonOpen(sched) ? 'Fermer l’après-midi' : 'Ouvrir l’après-midi'"
                  >
                    <mat-icon class="w-3.5! h-3.5! text-xs!">{{
                      isAfternoonOpen(sched) ? 'brightness_medium' : 'block'
                    }}</mat-icon>
                    <span>Après-midi</span>
                  </button>

                  @if (isAfternoonOpen(sched)) {
                    <input
                      type="time"
                      class="px-1.5 py-0.5 bg-neutral-1 dark:bg-neutral-2 border border-neutral-3 dark:border-neutral-4 text-neutral-12 rounded text-xs font-mono w-20"
                      [value]="sched.afternoonOpen || '14:00'"
                      (change)="onDayTimeChange(d.key, 'afternoonOpen', $any($event.target).value)"
                      aria-label="Ouverture après-midi"
                    />
                    <span class="text-neutral-8 dark:text-neutral-9">-</span>
                    <input
                      type="time"
                      class="px-1.5 py-0.5 bg-neutral-1 dark:bg-neutral-2 border border-neutral-3 dark:border-neutral-4 text-neutral-12 rounded text-xs font-mono w-20"
                      [value]="sched.afternoonClose || '19:00'"
                      (change)="onDayTimeChange(d.key, 'afternoonClose', $any($event.target).value)"
                      aria-label="Fermeture après-midi"
                    />
                    <button
                      type="button"
                      class="p-0.5 rounded text-neutral-8 dark:text-neutral-9 hover:text-error-11 hover:bg-error-2 dark:hover:bg-error-3/30 transition-colors cursor-pointer"
                      title="Fermer l'après-midi"
                      (click)="toggleAfternoonOpen(d.key)"
                    >
                      <mat-icon class="w-3.5! h-3.5! text-xs!">close</mat-icon>
                    </button>
                  } @else {
                    <span class="text-[11px] text-neutral-9 dark:text-neutral-10 italic px-1">Fermé</span>
                    <button
                      type="button"
                      class="text-[11px] font-semibold text-primary-11 hover:underline cursor-pointer px-1"
                      (click)="toggleAfternoonOpen(d.key)"
                    >
                      Ouvrir
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          <span class="text-xs text-neutral-8 dark:text-neutral-9 italic">Fermé toute la journée</span>
        }
      </div>
    }
  </div>

  <!-- Notes / Précisions -->
  <mat-form-field appearance="outline" class="w-full pt-2" subscriptSizing="dynamic">
    <mat-label>Précisions sur vos disponibilités ou horaires d'accueil</mat-label>
    <input
      matInput
      aria-label="Précisions sur vos disponibilités"
      placeholder="Ex : Accueil téléphonique assuré du lundi au samedi, rendez-vous possibles en soirée"
      [value]="hours()?.notes || ''"
      (input)="onNotesChange($any($event.target).value)"
    />
    <mat-icon matPrefix class="mr-2 text-neutral-8">info</mat-icon>
  </mat-form-field>
</div>
